import React from 'react';

import { Card, CardContent } from '@/components/ui/card';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';

/**
 * Wraps the note content in a Note / Transcript tab pair when a meeting
 * transcript is available; renders the note content as-is otherwise.
 */
export const NoteTranscriptTabs = ({
    transcript,
    children,
}: {
    transcript: string | null;
    children: React.ReactNode;
}) => {
    if (!transcript) {
        return <>{children}</>;
    }

    return (
        <Tabs defaultValue="note">
            <TabsList className="border-0 px-0">
                <TabsTrigger value="note">Note</TabsTrigger>
                <TabsTrigger value="transcript">Transcript</TabsTrigger>
            </TabsList>
            <TabsContent value="note">{children}</TabsContent>
            <TabsContent value="transcript">
                <Card className="bg-white">
                    <CardContent className="p-6">
                        <p className="text-sm whitespace-pre-wrap text-slate-700">{transcript}</p>
                    </CardContent>
                </Card>
            </TabsContent>
        </Tabs>
    );
};
